import { motion } from "framer-motion";
import { MapPin, Clock } from "lucide-react";

const branches = [
  {
    id: "zeytinburnu",
    name: "Zeytinburnu",
    address: "Seyitnizam, Mevlana Cd. No:81-83/D, Zeytinburnu/İstanbul",
    image: "/assets/zeytinburnu/image00022.jpeg",
    note: "Alkolsüz Menü",
    hours: "10:30 - 00:00",
  },
  {
    id: "caddebostan",
    name: "Caddebostan",
    address: "Caddebostan, Yener Sk. No:5 D:1a, Kadıköy/İstanbul",
    image: "/assets/caddebostan/image00032.jpeg",
    note: "Alkollü Menü",
    hours: "14:30 - 00:30",
  },
];

export default function BranchSelectionScreen({ onSelect }) {
  return (
    <div className="fixed inset-0 z-[100] bg-[#0a0a0a] flex flex-col items-center justify-center px-6" data-testid="branch-selection-screen">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] }}
        className="text-center mb-12"
      >
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight mb-3">
          TEPSİ <span className="text-[#8B1A1A]">ET</span>
        </h1>
        <p className="font-body text-sm uppercase tracking-[0.3em] text-[#8B1A1A]">Şubenizi Seçin</p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-[900px] w-full">
        {branches.map((branch, i) => (
          <motion.button
            key={branch.id}
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.3 + i * 0.15, ease: [0.25, 0.46, 0.45, 0.94] }}
            onClick={() => onSelect(branch.id)}
            data-testid={`select-branch-${branch.id}`}
            className="group relative overflow-hidden border border-white/10 hover:border-[#8B1A1A]/60 transition-all duration-500 cursor-pointer text-left"
          >
            <div className="relative aspect-[4/3] overflow-hidden">
              <img
                src={branch.image}
                alt={branch.name}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-60 group-hover:opacity-80"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/40 to-transparent" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <h2 className="font-heading text-2xl sm:text-3xl text-white mb-2 group-hover:text-[#8B1A1A] transition-colors duration-300">
                {branch.name}
              </h2>
              <div className="flex items-start gap-2 mb-2">
                <MapPin className="w-4 h-4 text-[#8B1A1A] mt-0.5 shrink-0" />
                <span className="font-body text-xs text-white/60 leading-relaxed">{branch.address}</span>
              </div>
              <div className="flex items-center gap-2 mb-2">
                <Clock className="w-4 h-4 text-[#8B1A1A] shrink-0" />
                <span className="font-body text-xs text-white/60">{branch.hours}</span>
              </div>
              <span className="font-body text-[10px] uppercase tracking-[0.2em] text-[#8B1A1A]/80">{branch.note}</span>
            </div>
          </motion.button>
        ))}
      </div>
    </div>
  );
}
